import React, { useMemo } from 'react'
import useStyles from './styles'
import { Box, Typography } from '@material-ui/core'
import useEventNoun from 'hooks/useEventNoun'
import classnames from 'clsx'
import { useSelector } from 'react-redux'

const ItemType = ({ className, item }) => {
  const classes = useStyles()

  const event = useSelector(state => state.event.event)

  const eventNoun = useEventNoun()

  const label = useMemo(() => {
    if (item.item_type === 'auction') {
      if (item.live_auction) {
        return `Live ${eventNoun}`
      } else {
        return 'Bid Now'
      }
    } else {
      return `${event.auction_format === 10 ? 'Vote' : 'Purchase'}`
    }
  }, [item.item_type, item.live_auction, item.open_item])

  const type = useMemo(() => {
    if (item.item_type === 'auction') {
      if (item.live_auction) {
        return 'live'
      } else {
        return 'slient'
      }
    } else if (item.item_type === 'fixed') {
      if (item.open_item) {
        return 'open'
      } else {
        return 'fixed'
      }
    } else {
      return item.item_type
    }
  }, [item.item_type, item.live_auction, item.open_item])

  return (
    <Box
      className={classnames(
        classes.itemType,
        classes[`${type}Type`],
        className
      )}
    >
      <Typography variant="h3">{label}</Typography>
    </Box>
  )
}

export default ItemType



// WEBPACK FOOTER //
// ./src/components/ItemsList/Item/ItemType/index.jsx